import Button from "@mui/material/Button";
import React from "react";
import { useSelector } from "react-redux";
import {
  selectIAmAnnouncer,
  selectValidAnnouncements,
} from "../../store/selectors";
import { useAnnouncements } from "../../hooks/useAnnouncements";
import { getAnnouncementName } from "../../helpers/getAnnouncementName";

export function AnnouncementPicker() {
  const { makeAnnouncement } = useAnnouncements();

  const validAnnouncements = useSelector(selectValidAnnouncements);
  const iAmActiveAnnouncer = useSelector(selectIAmAnnouncer);

  if (validAnnouncements === undefined) {
    return <div className="text-emerald-200 animate-pulse">Loading...</div>;
  }

  if (!iAmActiveAnnouncer) {
    return (
      <div className="text-emerald-100 text-lg font-medium animate-pulse">
        Waiting for other players to make announcements...
      </div>
    );
  }

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-2 text-white">Make Announcements</h2>
      <p className="text-emerald-200 mb-6">Choose an announcement or pass</p>
      <div className="flex flex-wrap items-center justify-center gap-3 max-w-2xl mx-auto">
        {validAnnouncements.map((a) => {
          const isPass = a.slug === 'pass';
          return (
            <Button
              key={a.slug + a.base}
              variant={isPass ? "outlined" : "contained"}
              className="!rounded-full"
              onClick={() => makeAnnouncement(a)}
              sx={{
                backgroundColor: isPass ? 'transparent' : '#059669',
                borderColor: isPass ? 'rgba(255,255,255,0.5)' : '#059669',
                color: 'white',
                '&:hover': {
                  backgroundColor: isPass ? 'rgba(255,255,255,0.1)' : '#047857',
                  borderColor: isPass ? 'white' : '#047857',
                },
              }}
            >
              {getAnnouncementName(a)}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
